import { useUIStore } from "@/stores/ui";
import type { Project } from "@/types/stores/database";
import { Button, Flex, Group, Text, Title } from "@mantine/core";
import { IconFolder, IconPlus } from "@tabler/icons-react";

export function ProjectHeader({ project }: { project: Project }) {
  const openModal = useUIStore((state) => state.openModal);

  return (
    <Flex justify="space-between" align="flex-start">
      <Flex direction="column">
        <Group gap="xs">
          <IconFolder
            color="var(--mantine-color-eu_flag-filled)"
            stroke={1.6}
            size={24}
          />
          <Title fz={20} fw={500}>
            {project.title}
          </Title>
        </Group>
        <Text fz={15} fw={400} c="gray.9">
          {project.dataflows.length || "No"} workspace
          {project.dataflows.length == 1 ? "" : "s"}
        </Text>
      </Flex>
      {project.dataflows.length > 0 && (
        <Button
          leftSection={<IconPlus size={16} />}
          onClick={() =>
            openModal(undefined, "workspace", undefined, { defaultProjectId: project.id })
          }
        >
          Create Workspace
        </Button>
      )}
    </Flex>
  );
}
